import store from '../../store';

class LoadingService {
  showLoading(toShow: any) {
    store.dispatch('showLoadingAnimation', toShow);
  }
}

export const loadingService = new LoadingService()
